module.exports = __webpack_public_path__ + "img/40_38_052_260.b35fcfd4.jpg";